export default {
  SET_CAMPANHA_PENDENCIA(state, payload) {
    state.verificado = true;
    state.temPendencia = Boolean(payload.temPendencia);
    state.pendenciaAtual = payload.campanha || null;
  },

  CLEAR_CAMPANHA_PENDENCIA(state) {
    state.verificado = true;
    state.temPendencia = false;
    state.pendenciaAtual = null;
  }
};
